import { render, staticRenderFns } from "./installationRevenueConfig.vue?vue&type=template&id=9f64ab76"
import script from "./installationRevenueConfig.vue?vue&type=script&lang=js"
export * from "./installationRevenueConfig.vue?vue&type=script&lang=js"
import style0 from "./installationRevenueConfig.vue?vue&type=style&index=0&id=9f64ab76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports